import {Component, Input} from '@angular/core';
import {CommonService} from '@shared/services/common.service';
import {AuthService} from '@services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [
    CommonService,
  ],
})
export class HeaderComponent {
  @Input() hideActions = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute) {
  }

  IsLoggedIn() {
    return AuthService.User;
  }

  getEmail() {
    return AuthService.User.email;
  }

  getUserRole() {
    return AuthService.User.rolename;
  }

  showMyJobs(): boolean {
    return (!this.router.url.toLowerCase().includes('/engineer'));
  }

  viewJobs(): void {
    this.router.navigate(['engineer']);
  }

  logout() {
    this.authService.logout();
  }
}
